import React, { useState, useContext } from 'react'
import { AuthContext } from '@/layout/Auth'
import { PermissionInfo } from '@/types'
import Table, { pageProps } from '@/components/Table'
import { permissionColumns } from './column'
import { PlainCard } from '../components'
import { useQuery } from '@tanstack/react-query'
import { getDetailPermissions } from '@/api'

const Permission: React.FC<unknown> = () => {
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const [total, setTotal] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [data, setData] = useState<PermissionInfo[]>([])
  const [rows, setRows] = useState<number>(10)

  useQuery(
    ['getDetailPermissions', orgInfo?.id, page, rows],
    () =>
      getDetailPermissions({
        // @ts-ignore
        id: orgInfo?.id,
        query: { page, size: rows },
      }),
    {
      onSuccess: (res) => {
        setTotal(res.total)
        setData(res.data)
      },
      refetchOnMount: true,
      enabled: !!orgInfo?.id,
    },
  )

  const handlePageChange = (value: pageProps) => {
    setPage(value.page)
    // @ts-ignore
    setRows(value.rowsPerPage)
  }

  return (
    <PlainCard>
      <Table<PermissionInfo>
        sx={{ flex: 1 }}
        columns={permissionColumns()}
        data={data}
        rowKey={'id'}
        pagination={{
          page,
          total,
          onChange: handlePageChange,
          rowsPerPage: rows,
        }}
      />
    </PlainCard>
  )
}

export default Permission
